// Lightweight inline SVG icons for the raffle page.
// Self-contained so the feature does not depend on the shared Icon component.
// All icons inherit `currentColor` and are decorative by default (aria-hidden).

import React from 'react';

const base = (props) => ({
  width: props.size || 20,
  height: props.size || 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: props.strokeWidth || 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': props['aria-hidden'] ?? true,
  focusable: 'false',
  className: props.className,
});

export const GlobeIcon = (p) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c2.5 2.5 2.5 15 0 18M12 3c-2.5 2.5-2.5 15 0 18" />
  </svg>
);

export const ArrowRightIcon = (p) => (
  <svg {...base(p)}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

export const ArrowDownIcon = (p) => (
  <svg {...base(p)}>
    <path d="M12 5v14M6 13l6 6 6-6" />
  </svg>
);

export const SparklesIcon = (p) => (
  <svg {...base(p)}>
    <path d="M12 3l1.8 4.6L18.4 9l-4.6 1.4L12 15l-1.8-4.6L5.6 9l4.6-1.4L12 3z" />
    <path d="M19 14l.8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8L19 14z" />
  </svg>
);

export const TrophyIcon = (p) => (
  <svg {...base(p)}>
    <path d="M8 4h8v4a4 4 0 0 1-8 0V4z" />
    <path d="M8 5H5a2 2 0 0 0 2 3M16 5h3a2 2 0 0 1-2 3" />
    <path d="M12 12v4M9 20h6M10 20l.5-4M14 20l-.5-4" />
  </svg>
);

export const CheckIcon = (p) => (
  <svg {...base(p)}>
    <path d="M4 12.5l5 5L20 6.5" />
  </svg>
);

export const ShieldCheckIcon = (p) => (
  <svg {...base(p)}>
    <path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

export const UsersIcon = (p) => (
  <svg {...base(p)}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3.5 19a5.5 5.5 0 0 1 11 0" />
    <path d="M16 5.2a3.2 3.2 0 0 1 0 5.6M17.5 19a5.5 5.5 0 0 0-3-4.9" />
  </svg>
);

export const RefreshIcon = (p) => (
  <svg {...base(p)}>
    <path d="M20 11a8 8 0 0 0-14-4.5L4 8M4 4v4h4" />
    <path d="M4 13a8 8 0 0 0 14 4.5L20 16M20 20v-4h-4" />
  </svg>
);

export const CloseIcon = (p) => (
  <svg {...base(p)}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const BoltIcon = (p) => (
  <svg {...base(p)}>
    <path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" />
  </svg>
);

export const GiftIcon = (p) => (
  <svg {...base(p)}>
    <path d="M4 11h16v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-9z" />
    <path d="M3 7h18v4H3zM12 7v14" />
    <path d="M12 7S10.5 3.5 8.5 4 8 7 12 7zM12 7s1.5-3.5 3.5-3 .5 3-3.5 3z" />
  </svg>
);

export const SunIcon = (p) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M2 12h2M20 12h2M5 5l1.5 1.5M17.5 17.5L19 19M19 5l-1.5 1.5M6.5 17.5L5 19" />
  </svg>
);

export const MoonIcon = (p) => (
  <svg {...base(p)}>
    <path d="M20 14.5A8 8 0 0 1 9.5 4 7 7 0 1 0 20 14.5z" />
  </svg>
);

export const HexIcon = (p) => (
  <svg {...base(p)}>
    <path d="M7 3.5h10L21.5 12 17 20.5H7L2.5 12 7 3.5z" />
  </svg>
);

export const ChevronDownIcon = (p) => (
  <svg {...base(p)}>
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export const TagIcon = (p) => (
  <svg {...base(p)}>
    <path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9-9-9z" />
    <circle cx="8" cy="8" r="1.6" fill="currentColor" stroke="none" />
  </svg>
);

export const CalendarIcon = (p) => (
  <svg {...base(p)}>
    <rect x="3" y="5" width="18" height="16" rx="3" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </svg>
);

export const CopyIcon = (p) => (
  <svg {...base(p)}>
    <rect x="9" y="9" width="12" height="12" rx="2.5" />
    <path d="M6 15H4.5A1.5 1.5 0 0 1 3 13.5v-9A1.5 1.5 0 0 1 4.5 3h9A1.5 1.5 0 0 1 15 4.5V6" />
  </svg>
);

export const MailIcon = (p) => (
  <svg {...base(p)}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M4 7l8 6 8-6" />
  </svg>
);

export const PhoneIcon = (p) => (
  <svg {...base(p)}>
    <path d="M4 5c0 8 7 15 15 15l1.5-3.2-4-2-1.8 1.6a12 12 0 0 1-5.1-5.1L11.2 9.5l-2-4L6 7C5 6.6 4 5.9 4 5z" />
  </svg>
);

export const LocationIcon = (p) => (
  <svg {...base(p)}>
    <path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z" />
    <circle cx="12" cy="10" r="2.6" />
  </svg>
);

// --- Brand glyphs (filled, so they read at small sizes). ---
const brand = (props) => ({
  width: props.size || 22,
  height: props.size || 22,
  viewBox: '0 0 24 24',
  fill: 'currentColor',
  'aria-hidden': props['aria-hidden'] ?? true,
  focusable: 'false',
  className: props.className,
});

export const InstagramIcon = (p) => (
  <svg {...base(p)}>
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const FacebookIcon = (p) => (
  <svg {...brand(p)}>
    <path d="M14 8.5V7c0-.7.3-1 1-1h1.5V3H14c-2.2 0-3.5 1.3-3.5 3.6v1.9H8V12h2.5v9H14v-9h2.3l.5-3.5H14z" />
  </svg>
);

export const YoutubeIcon = (p) => (
  <svg {...brand(p)}>
    <path d="M22 12s0-3.2-.4-4.7a2.5 2.5 0 0 0-1.8-1.8C18.3 5 12 5 12 5s-6.3 0-7.8.5A2.5 2.5 0 0 0 2.4 7.3 26 26 0 0 0 2 12c0 1.7 0 3.2.4 4.7a2.5 2.5 0 0 0 1.8 1.8C5.7 19 12 19 12 19s6.3 0 7.8-.5a2.5 2.5 0 0 0 1.8-1.8C22 15.2 22 13.7 22 12zM10 15V9l5.2 3L10 15z" />
  </svg>
);

export const TiktokIcon = (p) => (
  <svg {...brand(p)}>
    <path d="M16 3c.3 2 1.5 3.6 3.5 4v3c-1.4 0-2.7-.4-3.8-1.1v5.9a5.8 5.8 0 1 1-5.8-5.8c.3 0 .6 0 .9.1v3.1a2.7 2.7 0 1 0 1.9 2.6V3H16z" />
  </svg>
);

export const TelegramIcon = (p) => (
  <svg {...brand(p)}>
    <path d="M21 4.5L3.7 11.2c-.9.3-.9 1.5 0 1.8l4.3 1.4 1.6 5c.2.6 1 .7 1.4.2l2.3-2.5 4.3 3.2c.6.4 1.4.1 1.5-.6L21.9 5.4c.1-.7-.5-1.2-.9-.9zM9.7 13.6l7.4-4.6-6.1 5.7-.2 3-1.1-4.1z" />
  </svg>
);

export const ViberIcon = (p) => (
  <svg {...brand(p)}>
    <path d="M12 2C7.6 2 4 5 4 8.9c0 1.9.9 3.6 2.3 4.9v3.4l2.7-1.6c.9.2 1.9.4 3 .4 4.4 0 8-3 8-6.9S16.4 2 12 2zm-.6 4h.2c1.8 0 3.5.7 4.8 2 .4.4.6.9.7 1.5 0 .3-.2.6-.5.6-.3 0-.5-.2-.5-.5-.1-.4-.2-.7-.5-1a5.1 5.1 0 0 0-3.9-1.6c-.3 0-.5-.3-.5-.5s.2-.5.2-.5zm-2 1.3c.2 0 .4.1.5.3l.7 1.2c.1.3.1.6-.1.8l-.4.4c-.1.1-.1.2 0 .3.3.6 1 1.3 1.6 1.6.1.1.2.1.3 0l.4-.4c.2-.2.5-.2.8-.1l1.2.7c.2.1.3.4.2.6-.3.9-1.3 1.3-2.1 1-1.8-.6-3.4-2.2-4-4-.3-.8.1-1.8 1-2.1a.6.6 0 0 1 .2-.3zm2.7.4c1 0 1.9.4 2.6 1.1.4.4.6 1 .7 1.5 0 .3-.2.5-.4.5-.3 0-.5-.2-.5-.4-.1-.4-.2-.7-.5-1a2.9 2.9 0 0 0-1.9-.7c-.3 0-.5-.3-.4-.5 0-.3.2-.5.4-.5zm.2 1.5c.5 0 1 .2 1.3.6.2.2.3.5.3.8 0 .3-.2.5-.5.4-.2 0-.4-.2-.4-.4 0-.1-.1-.3-.2-.4a.9.9 0 0 0-.6-.2c-.3 0-.5-.3-.4-.5 0-.3.2-.5.5-.5z" />
  </svg>
);

export const WhatsappIcon = (p) => (
  <svg {...brand(p)}>
    <path d="M12 2a10 10 0 0 0-8.5 15.2L2 22l4.9-1.5A10 10 0 1 0 12 2zm0 18a8 8 0 0 1-4.1-1.1l-.3-.2-2.9.9.9-2.8-.2-.3A8 8 0 1 1 12 20zm4.5-6c-.2-.1-1.4-.7-1.6-.8-.2-.1-.4-.1-.5.1-.2.2-.6.8-.8 1-.1.1-.3.1-.5.1-.2-.1-1-.4-1.9-1.2-.7-.6-1.2-1.4-1.3-1.6-.1-.2 0-.4.1-.5l.4-.4c.1-.1.1-.2.2-.4v-.4c0-.1-.5-1.3-.7-1.8-.2-.4-.4-.4-.5-.4h-.5c-.2 0-.4 0-.6.3-.2.2-.8.8-.8 2s.8 2.3.9 2.4c.1.2 1.7 2.6 4 3.5.6.3 1 .4 1.4.5.6.2 1.1.2 1.5.1.5-.1 1.4-.6 1.6-1.1.2-.5.2-1 .1-1.1 0-.1-.2-.2-.4-.3z" />
  </svg>
);

const icons = {
  GlobeIcon,
  ArrowRightIcon,
  ArrowDownIcon,
  SparklesIcon,
  TrophyIcon,
  CheckIcon,
  ShieldCheckIcon,
  UsersIcon,
  RefreshIcon,
  CloseIcon,
  BoltIcon,
  GiftIcon,
  ChevronDownIcon,
  TagIcon,
  CalendarIcon,
  CopyIcon,
  MailIcon,
  PhoneIcon,
  LocationIcon,
  InstagramIcon,
  FacebookIcon,
  YoutubeIcon,
  TiktokIcon,
  TelegramIcon,
  ViberIcon,
  WhatsappIcon,
};

export default icons;
